import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\"><path d=\"M11.2693 38.7308H19.0578V26.4808H28.9423V38.7308H36.7308V19.6347L24 10.0385L11.2693 19.6282V38.7308ZM9.00006 41V18.5001L24 7.21165L39 18.5001V41H26.6731V28.75H21.3269V41H9.00006Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol